import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const lineCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default lineCommands;
